import { render, staticRenderFns } from "./PointMallVoucher.vue?vue&type=template&id=09033024&scoped=true"
import script from "./PointMallVoucher.vue?vue&type=script&lang=js"
export * from "./PointMallVoucher.vue?vue&type=script&lang=js"
import style0 from "./PointMallVoucher.vue?vue&type=style&index=0&id=09033024&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09033024",
  null
  
)

export default component.exports